import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/system";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section12 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <Stack spacing={1}>
                  <Typography>
                    እግዚአብሔር ለአጥቢያይቱ ያደረጋቸው እርሱን የምናመሰግንባቸው ጉዳዮች
                  </Typography>
                  <StyledTextField
                    fullWidth
                    type="text"
                    defaultValue={formState.thanksgiving.main_points}
                    onBlur={e =>
                      handleChange("thanksgiving", {
                        main_points: e.target.value
                      })
                    }
                    multiline
                    minRows={3}
                    key={formState.thanksgiving.main_points}
                    disabled={!isEditingEnabled}
                  />
                </Stack>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Stack spacing={1}>
                  <Typography>
                    ከዚህ ውጪ የተሰሩና መወሳት ያለባቸው ጉዳዮች ካሉ ከዚህ በታች ይጻፍ
                  </Typography>
                  <StyledTextField
                    fullWidth
                    type="text"
                    defaultValue={formState.thanksgiving.additional_points}
                    onBlur={e =>
                      handleChange("thanksgiving", {
                        additional_points: e.target.value
                      })
                    }
                    multiline
                    minRows={3}
                    key={formState.thanksgiving.additional_points}
                    disabled={!isEditingEnabled}
                  />
                </Stack>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Stack spacing={1}>
                  <Typography>ያጋጠሙ ችግሮች</Typography>
                  <StyledTextField
                    fullWidth
                    type="text"
                    defaultValue={formState.thanksgiving.problems}
                    onBlur={e =>
                      handleChange("thanksgiving", {
                        problems: e.target.value
                      })
                    }
                    multiline
                    minRows={3}
                    key={formState.thanksgiving.problems}
                    disabled={!isEditingEnabled}
                  />
                </Stack>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(13)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
